import { createFileRoute } from '@tanstack/react-router';

import { trpc } from '../../../../../services/trpc';
import { BudgetSection } from './-budget-section';

export const Route = createFileRoute('/app/projets/$slug/budget/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: project } = trpc.projects.get.useQuery({ slug: params.slug });

  if (!project) {
    return null;
  }

  return <BudgetSection project={project} />;
}
